module.exports = __webpack_public_path__ + "img/img11.1084e7b0.svg";